import React, {Component} from 'react'
import Loading from '../Loading'
import utils from '../../utils/utils'
import _ from 'lodash'
import { Collapse, Button, Badge, Container, Row, Col} from 'reactstrap';
import InfoBadge from './InfoBadge'
import WorwerItem from './WorkerItem'


export default class ServerItem extends Component {
  constructor(props, context) {
    super(props, context)
    this.state = {
      collapse: false
    }
    this.toggle = this.toggle.bind(this)
  }
  toggle() {
    this.setState({collapse: !this.state.collapse})
  }
  pushWorkerItemOnList(list, title, item){
    try {
      if (list.length === 0) {
        list.push(
          <h4 key={`h4-${item.instance_id}`} className='text-black'> {`${title}`} </h4>
        )
      }
      list.push(
        <WorwerItem key={item.instance_id} worker={item}/>
      )
    } catch (error) {
      console.error(`pushWorkerItemOnList ${error.message}`)
    }
  }
  render(){
    let workers = []
    let pollers = []
    let uploaders = []
    let others = []
    for (const worker of this.props.server.workers) {
      switch (worker.worker_type) {
        case 'WORKER':
          this.pushWorkerItemOnList(workers,'WORKERS', worker)
          break;
        case 'POLLER':
          this.pushWorkerItemOnList(pollers, 'POLLERS', worker)
          break;
        case 'UPLOADER':
          this.pushWorkerItemOnList(uploaders, 'UPLOADERS', worker)
        default:
          this.pushWorkerItemOnList(others, 'EXTRA', worker)
          break;
      }
    }
    return(
      <div>
       <div className="panel panel-default mt5 mb5">
        <div className="panel-body worker-item-fix">
      <Button key={this.props.server.ip} className='mt5' color="link" size="lg" onClick={this.toggle} block>
        <Container fluid={true}>
          <Row className='worker-text'>
            <Col sm='5'>
              {utils.getCollapseArrow(this.state.collapse, 'mt10', 'left')}
              <h3 className='pull-left server-title'>
              {this.props.server.server_host}
              <Badge color='primary' className='ms-badge'>
                    <span className='badget-zone-text'>{this.props.server.workers.length || 0}</span>
              </Badge>
              </h3>
            </Col>
            <Col sm="7">
            <Badge color='primary' className='ms-badge'>
                    <h6>{this.props.server.ip}</h6>
            </Badge>
            <Badge color='primary' className='ms-badge'>
                    <h6>{this.props.server.server_type}</h6>
            </Badge>
            <Badge color='primary' className='ms-badge'>
                    <h6>{this.props.server.jobs_type || 'Not Found'}</h6>
            </Badge>
            <InfoBadge title={(utils.isOnline(this.props.server.notified)) ? 'Connected':'Offline'} value={this.props.server.notified} type={'time'}/>
            <InfoBadge title={'Network'} value={this.props.server.network} type={'none'}/>
            <InfoBadge title={'Storage'} value={this.props.server.storage} type={'none'}/>
            <InfoBadge title={'Avg Load'} value={this.props.server.avg_load} type={'none'}/>
            </Col>
          </Row>
        </Container>
      </Button>
      <Collapse isOpen={this.state.collapse}>
       <Container fluid={true}>
          {pollers}
          {workers}
          {uploaders}
          {others}
       </Container>
      </Collapse>
        </div>
      </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/server/ServerItem.js